export default "__VITE_ASSET__D_NK_Cwk__"